<template>
    <v-navigation-drawer class="brown_9" app permanent width="380">
        <!-- navigation header -->
        <div class="card__title d-flex text-xs-center py-4 primary white--text">
            <span>Список вызовов</span>
            <span @click="logout">
                <svg
                    class="card__exit"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    viewBox="0 0 512 512"
                >
                    <path
                        fill="currentColor"
                        d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                    />
                </svg>
            </span>
        </div>

        <template v-for="(claim, index) in claims">
            <v-card
                :key="claim.id"
                :status="claim.status"
                :class="{ callCard__active: claim.status === 1 }"
                class="callCard my-3 mx-2 pb-3 elevation-5"
            >
                <!-- name -->
                <v-card-title class="card__title text-xs-left">
                    <span class="callCard__fullname mr-2">{{
                        claim.user.fullname
                    }}</span>

                    <v-spacer></v-spacer>

                    <!-- card on/off switcher -->
                    <span
                        class="iconContainer"
                        @click="toggle(index, claim.user.id)"
                    >
                        <v-icon
                            v-if="selected.indexOf(index) < 0"
                            color="indigo_7"
                            size="50"
                            >more_horiz_border</v-icon
                        >
                        <v-icon v-else color="brown_6" size="50"
                            >more_horiz</v-icon
                        >
                    </span>
                </v-card-title>

                <!-- phone -->
                <div class="callCard__phone">
                    {{ claim.user.phone | phone }}
                </div>

                <!-- cars -->
                <div class="crew__wrapper">
                    <template
                        v-if="
                            claim.nearest_cars.length || claim.raid_car.length
                        "
                    >
                        <div class="crew__title">Назначить экипаж</div>
                        <div class="crew__item-container">
                            <!-- raid cars -->
                            <template v-for="raidCar in claim.raid_car">
                                <!-- tooltip -->
                                <v-tooltip
                                    class="mr-2 mb-2"
                                    bottom
                                    :key="raidCar.id"
                                >
                                    <template
                                        slot="activator"
                                        color="primary"
                                        dark
                                    >
                                        <div class="crew__item crew__raid">
                                            <span class="crew__text">{{
                                                raidCar.board_number
                                            }}</span>
                                        </div>
                                    </template>
                                    <span>экипаж назначен</span>
                                    <br />
                                    <span
                                        >борт: {{ raidCar.board_number }}</span
                                    >
                                    <br />
                                    <span
                                        >телефон:
                                        {{ claim.user.phone | phone }}</span
                                    >
                                </v-tooltip>
                            </template>

                            <!-- nearest cars -->
                            <template
                                v-for="(
                                    nearestCar, index
                                ) in claim.nearest_cars"
                            >
                                <div
                                    class="crew__item"
                                    :key="index"
                                    :clientId="claim.user.id"
                                    :crewId="nearestCar.id"
                                    @click="assignСall($event)"
                                >
                                    <span class="crew__text">{{
                                        nearestCar.board_number
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <div class="crew__title">Нет свободных экипажей</div>
                    </template>
                </div>

                <!-- buttons  -->
                <v-card-actions class="text-xs-center">
                    <v-spacer></v-spacer>

                    <v-btn
                        class="btn"
                        color="indigo_5"
                        large
                        dark
                        @click="onMap(claim.user.fullname)"
                        >На карте</v-btn
                    >

                    <v-btn
                        class="btn"
                        :class="{
                            callCard__listening:
                                audioSelected.indexOf(index) >= 0,
                        }"
                        @click="audioToggle(index, claim.user.id)"
                        color="indigo_5"
                        large
                        dark
                        outline
                        disabled
                    >
                        <span v-if="audioSelected.indexOf(index) < 0"
                            >Аудио</span
                        >
                        <span v-else>Слушаю</span>
                    </v-btn>

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </template>
    </v-navigation-drawer>
</template>

<script>
import { bus } from '@/main';

export default {
    name: 'navigation',
    data: () => ({
        alreadyExInfo: false,
        isActive: true,
        audios: [
            {
                id: '1',
                name: 'Muscle Car',
                file: new Audio('http://ice912.echo.msk.ru:9120/24.aac'),
                isPlaying: false,
            },
        ],
        selected: [],
        audioSelected: [],
        close: true,
        visibleCard: true,
    }),

    computed: {
        claims() {
            let callsList = this.$store.getters['dispatcher/callsList'];

            return callsList.filter((claim) => claim.status === 1) || [];
        },
    },
    methods: {
        onMap(coords) {
            bus.$emit('launchShowOnMap', coords);
        },

        assignСall(e) {
            let element = e.currentTarget;
            let clientId = element.getAttribute('clientId');
            let crewId = element.getAttribute('crewId');

            let assignСallData = {
                car: crewId,
                id: clientId,
            };

            this.$store.dispatch('dispatcher/assignСall', assignСallData);
            this.$store.dispatch('notifications/ADD_NOTIFICATION', {
                id: `f${(+new Date()).toString(16)}`,
                type: 'success',
                text: 'экипаж назначен',
                timeStamp: new Date().getTime(),
            });
            this.$emit('onAssignCall', clientId);
        },

        play(audio) {
            audio.isPlaying = true;
            audio.file.play();
        },

        pause(audio) {
            audio.isPlaying = false;
            audio.file.pause();
        },

        // open and close cards with additional user info
        toggle(index, userId) {
            const i = this.selected.indexOf(index);

            if (i > -1) {
                this.selected.splice(i, 1);
            } else if (i == -1 && this.selected.length > 0) {
                this.selected.splice(i, 1);
                bus.$emit('toggle', userId);
                this.selected.push(index);
            } else {
                this.selected.push(index);
            }
            bus.$emit('toggle', userId);
        },

        // turn on / turn off audio
        audioToggle(index, userId) {
            const i = this.audioSelected.indexOf(index);

            if (i > -1) {
                this.audioSelected.splice(i, 1);
            } else if (i == -1 && this.audioSelected.length > 0) {
                this.audioSelected.splice(i, 1);
                this.audioSelected.push(index);
            } else {
                this.audioSelected.push(index);
            }
        },

        logout() {
            this.$store.dispatch('common/logout');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.card__title {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
}

.callCard {
    background: #ffffff;

    &__phone {
        color: $brown-5;
        font-size: 18px;
        margin: 0 0 20px 18px;
    }
    &__online {
        border-radius: 50%;
        height: 10px;
        width: 10px;
    }
    &__fullname {
        display: inline-block;
        max-width: 260px;
        // white-space: pre-wrap;
    }
    &__listening {
        // border-color: rgba(0, 0, 0, 0.3) !important;
        background-image: linear-gradient(
            45deg,
            rgba(84, 118, 133, 0.5) 25%,
            transparent 25%,
            transparent 50%,
            rgba(84, 118, 133, 0.5) 50%,
            rgba(84, 118, 133, 0.5) 75%,
            transparent 75%,
            transparent
        ) !important;
        background-size: 50px 50px !important;
        animation: loading-stripes 1.5s linear infinite;
    }
    &__active {
        animation: blink 400ms infinite alternate;
    }
}
// blink effect color switcher
@keyframes blink {
    from {
        background: #ffffff;
    }
    to {
        background: $error;
    }
}

// animation for audio button
@keyframes loading-stripes {
    0% {
        background-position: 0px;
    }
    100% {
        background-position: 50px;
    }
}

.crew {
    &__wrapper {
        margin: -10px 0 0 17px;
    }
    &__title {
        color: $indigo_1;
        font-size: 18px;
        font-weight: bold;
        margin: 0 0 5px 0;
    }
    &__item-container {
        display: flex;
        flex-wrap: wrap;
    }
    &__item {
        background-color: $brown-7;
        border-radius: 50%;
        cursor: pointer;
        display: table-cell;
        height: 50px;
        margin: 0 10px 10px 0;
        padding-top: 13px;
        text-align: center;
        vertical-align: middle;
        width: 50px;
    }
    &__raid {
        background-color: #bce3c1;
        cursor: default;
        padding: 0;
    }
    &__text {
        color: white;
        font-size: 18px;
        font-weight: bold;
    }
}

.cardSwitcher {
    cursor: pointer;
    padding: 5px;
    &__item {
        background-color: $indigo-7;
        border: 1px solid $indigo-7;
        border-radius: 50%;
        height: 8px;
        width: 8px;
    }
}

.iconContainer {
    cursor: pointer;
    width: 44px;
    flex-shrink: 0;
}

.active {
    background-color: white !important;
}
</style>
